var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.277,
    height: 155.277,
    viewBox: "0 0 155.277 155.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_340",
    "data-name": "Ret\\xE2ngulo 340",
    width: 155.277,
    height: 155.277,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_350",
    "data-name": "Grupo 350",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_328",
    "data-name": "Caminho 328",
    d: "M77.638,155.277h0a77.638,77.638,0,1,1,77.638-77.638,77.638,77.638,0,0,1-77.638,77.638",
    transform: "translate(0 0)",
    fill: "#411172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    "data-name": "Caminho 329",
    d: "M27.239,55.932c-5.962,0-9.61-3.768-9.61-10.085s3.678-10.085,9.581-10.085c4.092,0,7.385,1.691,8.364,5.4l-4.48,1.808c-.562-2.432-1.69-3.2-3.707-3.2-2.847,0-4.539,2.077-4.539,6.08,0,3.975,1.573,6.08,4.449,6.08a3.554,3.554,0,0,0,3.886-3.2l4.627,1.3c-1.157,4.094-4.42,5.9-8.572,5.9",
    transform: "translate(5.324 10.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_330",
    "data-name": "Caminho 330",
    d: "M48.5,51.538l-.385,2.818a4.147,4.147,0,0,1-2.018.475c-1.987,0-3.381-.684-3.825-2.285-.831,1.424-2.552,2.285-5.28,2.285-2.937,0-4.6-1.306-4.6-3.708,0-2.462,1.573-4.035,5.785-4.864l3.351-.654v-.534a1.988,1.988,0,0,0-2.105-2.2,2.472,2.472,0,0,0-2.759,2.285l-4.093-1.187c.5-2.818,2.818-4.567,6.852-4.567,4.567,0,7.088,1.868,7.088,5.695v5.4q0,1.158,1.068,1.157a2.9,2.9,0,0,0,.921-.118m-6.971-2.077V48.187l-2.4.562c-1.246.3-1.75.712-1.75,1.543s.534,1.275,1.453,1.275c1.246,0,2.7-.741,2.7-2.105",
    transform: "translate(9.781 11.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_331",
    "data-name": "Caminho 331",
    d: "M56.595,39.733,56.061,44a3.846,3.846,0,0,0-1.868-.445,3.208,3.208,0,0,0-3.321,3.5v7.475H45.827V39.7h4.449l.208,3.174a4.5,4.5,0,0,1,4.509-3.471,3.4,3.4,0,0,1,1.6.327",
    transform: "translate(13.84 11.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_332",
    "data-name": "Caminho 332",
    d: "M67.63,54.728a7.881,7.881,0,0,1-4.182,1.128c-3.351,0-5.428-1.306-5.458-4.746V44.316H55.439V40.728H57.99V37.405l5.043-1.393v4.716h4.449v3.588H63.032v5.963a1.728,1.728,0,0,0,1.958,1.987,3.455,3.455,0,0,0,2.135-.652Z",
    transform: "translate(16.743 10.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_333",
    "data-name": "Caminho 333",
    d: "M81.432,52.976l-.385,2.818a4.147,4.147,0,0,1-2.018.475c-1.987,0-3.381-.684-3.825-2.285-.831,1.424-2.552,2.285-5.28,2.285-2.937,0-4.6-1.306-4.6-3.708,0-2.462,1.573-4.035,5.785-4.864l3.351-.654v-.534a1.988,1.988,0,0,0-2.105-2.2A2.472,2.472,0,0,0,69.6,46.6L65.5,45.411c.5-2.818,2.818-4.567,6.852-4.567,4.567,0,7.088,1.868,7.088,5.695v5.4q0,1.158,1.068,1.157a2.9,2.9,0,0,0,.921-.118m-11.9-13.615H66.689c.12-3.174,1.453-4.716,3.916-4.716,2.282,0,2.728,1.69,3.855,1.69.682,0,1.008-.564,1.128-1.66h2.847c-.12,3.173-1.483,4.716-3.916,4.716-2.282,0-2.7-1.691-3.885-1.691-.652,0-.978.564-1.1,1.661M74.461,50.9V49.625l-2.4.562c-1.246.3-1.75.712-1.75,1.543S70.843,53,71.762,53c1.246,0,2.7-.741,2.7-2.105",
    transform: "translate(19.728 10.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_334",
    "data-name": "Caminho 334",
    d: "M93.879,47.118c0,4.864-2.877,7.712-7.83,7.712s-7.832-2.847-7.832-7.712,2.877-7.712,7.832-7.712,7.83,2.847,7.83,7.712m-10.619,0c0,2.906.919,4.123,2.789,4.123s2.788-1.217,2.788-4.123-.919-4.123-2.788-4.123-2.789,1.217-2.789,4.123",
    transform: "translate(23.622 11.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_339",
    "data-name": "Ret\\xE2ngulo 339",
    width: 10.856,
    height: 4.123,
    transform: "translate(120.404 56.438)",
    fill: "#f88339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_335",
    "data-name": "Caminho 335",
    d: "M29.822,65.059c0,4.923-2.314,7.77-6.11,7.77a4.783,4.783,0,0,1-4.479-2.758v8.69H14.19V57.7h4.419l.148,3.143a5.13,5.13,0,0,1,4.954-3.44c3.855,0,6.11,2.818,6.11,7.653m-5.073.059c0-2.789-1.068-4-2.789-4-1.69,0-2.728,1.306-2.728,3.857v.3c0,2.462.978,3.857,2.728,3.857,1.721,0,2.789-1.216,2.789-4",
    transform: "translate(4.285 17.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_336",
    "data-name": "Caminho 336",
    d: "M37.895,57.733,37.361,62a3.846,3.846,0,0,0-1.868-.445,3.208,3.208,0,0,0-3.321,3.5v7.475H27.127V57.7h4.449l.208,3.174a4.5,4.5,0,0,1,4.509-3.471,3.4,3.4,0,0,1,1.6.327",
    transform: "translate(8.192 17.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_337",
    "data-name": "Caminho 337",
    d: "M50.472,66.572H40.358a2.845,2.845,0,0,0,3.114,2.7c1.483,0,2.4-.594,2.729-1.631l4.092,1.3c-.859,2.581-3.38,3.886-6.821,3.886-5.191,0-8.009-2.819-8.009-7.713s2.788-7.712,7.742-7.712c4.834,0,7.415,2.819,7.415,7.5a9.378,9.378,0,0,1-.148,1.661M40.358,63.843h5.576c-.267-1.9-1.186-2.907-2.759-2.907-1.6,0-2.551.891-2.818,2.907",
    transform: "translate(10.71 17.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_338",
    "data-name": "Caminho 338",
    d: "M47.513,70.22l2.609-2.847a4.783,4.783,0,0,0,4.39,2.105c1.394,0,2.225-.415,2.225-1.038,0-.564-.712-.919-2.7-1.335-4.509-.891-6.14-2.344-6.14-4.776s2.314-4.924,7.148-4.924c3.56,0,5.518,1.039,6.793,2.789L59.23,62.746a4.47,4.47,0,0,0-4.035-1.988c-1.483,0-2.254.535-2.254,1.128s.652.979,2.729,1.365c4.389.772,6.139,2.167,6.139,4.717,0,2.728-2.282,4.864-7.058,4.864-3.263,0-5.725-.772-7.238-2.611",
    transform: "translate(14.349 17.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_339",
    "data-name": "Caminho 339",
    d: "M74.5,66.572H64.388a2.845,2.845,0,0,0,3.114,2.7c1.483,0,2.4-.594,2.729-1.631l4.092,1.3c-.859,2.581-3.38,3.886-6.821,3.886-5.191,0-8.009-2.819-8.009-7.713s2.788-7.712,7.742-7.712c4.834,0,7.415,2.819,7.415,7.5a9.378,9.378,0,0,1-.148,1.661M64.388,63.843h5.576c-.267-1.9-1.186-2.907-2.759-2.907-1.6,0-2.551.891-2.818,2.907",
    transform: "translate(17.967 17.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_340",
    "data-name": "Caminho 340",
    d: "M87.247,62.656v9.877H82.2V64.05c0-2.105-.861-2.788-2.105-2.788-1.453,0-2.67.978-2.67,3.44v7.83H72.386V57.7h4.509l.148,2.877a5.173,5.173,0,0,1,5.073-3.174c3.055,0,5.131,1.808,5.131,5.25",
    transform: "translate(21.861 17.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_341",
    "data-name": "Caminho 341",
    d: "M96.695,72.728a7.881,7.881,0,0,1-4.182,1.128c-3.351,0-5.428-1.306-5.458-4.746V62.316H84.5V58.728h2.551V55.405L92.1,54.012v4.716h4.449v3.588H92.1v5.963a1.728,1.728,0,0,0,1.958,1.987,3.455,3.455,0,0,0,2.135-.652Z",
    transform: "translate(25.52 16.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_342",
    "data-name": "Caminho 342",
    d: "M109.056,66.572H98.942a2.845,2.845,0,0,0,3.114,2.7c1.483,0,2.4-.594,2.729-1.631l4.092,1.3c-.859,2.581-3.38,3.886-6.821,3.886-5.191,0-8.009-2.819-8.009-7.713s2.788-7.712,7.742-7.712c4.834,0,7.415,2.819,7.415,7.5a9.376,9.376,0,0,1-.148,1.661M98.942,63.843h5.576c-.267-1.9-1.186-2.907-2.759-2.907-1.6,0-2.551.891-2.818,2.907",
    transform: "translate(28.403 17.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_343",
    "data-name": "Caminho 343",
    d: "M51.8,80l-4.687,1.543C46.907,79.825,46.165,79,44.831,79c-1.9,0-2.936,1.275-2.936,4.182,0,2.936,1.156,4.064,2.936,4.064,1.424,0,2.225-.861,2.462-2.4l4.539,1.454c-.415,2.581-2.819,4.537-6.971,4.537-5.19,0-8.009-2.847-8.009-7.712s2.877-7.712,7.8-7.712c4.8,0,6.674,2.2,7.148,4.6",
    transform: "translate(11.129 22.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_344",
    "data-name": "Caminho 344",
    d: "M65.065,83.118c0,4.864-2.877,7.712-7.83,7.712S49.4,87.982,49.4,83.118s2.877-7.712,7.832-7.712,7.83,2.847,7.83,7.712m-10.619,0c0,2.906.919,4.123,2.789,4.123s2.788-1.217,2.788-4.123-.919-4.123-2.788-4.123-2.789,1.217-2.789,4.123",
    transform: "translate(14.92 22.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_345",
    "data-name": "Caminho 345",
    d: "M87.588,80.656l-.059,9.877H82.546v-8.72c0-1.868-.8-2.551-2.017-2.551-1.512,0-2.609,1.126-2.609,3.351v7.919H72.877v-8.72c0-1.868-.831-2.551-2.018-2.551-1.393,0-2.609,1.008-2.609,3.44v7.83H63.207V75.7h4.509l.148,2.847a5.177,5.177,0,0,1,4.983-3.144,4.7,4.7,0,0,1,4.716,3,5.278,5.278,0,0,1,4.953-3c2.907,0,5.1,1.78,5.073,5.25",
    transform: "translate(19.089 22.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_346",
    "data-name": "Caminho 346",
    d: "M38.93,87.118a4.469,4.469,0,1,1-4.469-4.469,4.468,4.468,0,0,1,4.469,4.469",
    transform: "translate(5.327 22.015)",
    fill: "#3cd57a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.53b7056d85ad372ff4d6bff2c9be7421.svg";
export { ForwardRef as ReactComponent };